/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    func, shape, string,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';

import LinkOrATag from '../../../../GraphqlCommonComponents/LinkOrATag/LinkOrATag';
import noop from '../../../../../../helpers/noop';

const useStyles = makeStyles((theme) => ({
    text: (styles) => ({
        margin: styles?.margin || '8px 0',
        fontFamily: 'Area Variable',
        fontSize: styles.fontSize || '16px',
        color: styles?.color || '#000000',
    }),
    link: (styles) => ({
        color: styles?.color || '#000000',
    }),
}));

const MarkdownText = ({ data, handleClick }) => {
    const classes = useStyles({
        fontSize: data?.font_size,
        margin: data?.margin,
        color: data?.color?.color,
    });

    return (
        <ReactMarkdown
            source={data?.copy}
            escapeHtml={false}
            className={`${classes.text} markdown-body`}
            renderers={{
                linkReference: ({ href, children }) => <LinkOrATag href={href} handleCallback={handleClick} className={classes.link}>{children}</LinkOrATag>,
            }}
        />
    );
};

MarkdownText.propTypes = {
    data: shape({
        copy: string,
        font_size: string,
    }),
    handleClick: func,
};

MarkdownText.defaultProps = {
    data: {
        copy: '',
        font_size: '',
    },
    handleClick: noop,
};

export default MarkdownText;
